import React from "react";
import { useTranslation } from "react-i18next";

import "./PrivacyPolicyPage.css";

export default function PrivacyPolicyPage() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="pp-page-header">
        <h1>{t("PrivacyPolicyPage.Hero.Title")}</h1>
      </div>
      <div className="pp-page-container">
        <div className="paragraph-container">
          <h2>1. {t("PrivacyPolicyPage.ParagraphOne.Title")}</h2>
          <p>{t("PrivacyPolicyPage.ParagraphOne.Description.SectionOne")}</p>
          <p>{t("PrivacyPolicyPage.ParagraphOne.Description.SectionTwo")}</p>
          <p>{t("PrivacyPolicyPage.ParagraphOne.Description.SectionThree")}</p>
          <p>{t("PrivacyPolicyPage.ParagraphOne.Description.SectionFour")}</p>
        </div>
        <div className="paragraph-container">
          <h2>2. {t("PrivacyPolicyPage.ParagraphTwo.Title")}</h2>
          <p>{t("PrivacyPolicyPage.ParagraphTwo.Description")}</p>
          <h3>2.1 {t("PrivacyPolicyPage.ParagraphTwo.One.Title")}</h3>
          <p>{t("PrivacyPolicyPage.ParagraphTwo.One.Description")}</p>
          <h3>2.2 {t("PrivacyPolicyPage.ParagraphTwo.Two.Title")}</h3>
          <p>{t("PrivacyPolicyPage.ParagraphTwo.Two.Description")}</p>
          <h3>2.3 {t("PrivacyPolicyPage.ParagraphTwo.Three.Title")}</h3>
          <p>{t("PrivacyPolicyPage.ParagraphTwo.Three.Description")}</p>
          <h3>2.4 {t("PrivacyPolicyPage.ParagraphTwo.Four.Title")}</h3>
          <p>{t("PrivacyPolicyPage.ParagraphTwo.Four.Description")}</p>
        </div>
        <div className="paragraph-container">
          <h2>3. {t("PrivacyPolicyPage.ParagraphThree.Title")}</h2>
          <p>{t("PrivacyPolicyPage.ParagraphThree.Description")}</p>
          <h3>3.1 {t("PrivacyPolicyPage.ParagraphThree.One.Title")}</h3>
          <p>{t("PrivacyPolicyPage.ParagraphThree.One.Description")}</p>
          <h3>3.2 {t("PrivacyPolicyPage.ParagraphThree.Two.Title")}</h3>
          <p>{t("PrivacyPolicyPage.ParagraphThree.Two.Description")}</p>
          <h3>3.3 {t("PrivacyPolicyPage.ParagraphThree.Three.Title")}</h3>
          <p>{t("PrivacyPolicyPage.ParagraphThree.Three.Description")}</p>
          <h3>3.4 {t("PrivacyPolicyPage.ParagraphThree.Four.Title")}</h3>
          <p>{t("PrivacyPolicyPage.ParagraphThree.Four.Description")}</p>
        </div>
        <div className="paragraph-container">
          <h2>4. {t("PrivacyPolicyPage.ParagraphFour.Title")}</h2>
          <p>{t("PrivacyPolicyPage.ParagraphFour.List.Description")}</p>
          <ul>
            <li>{t("PrivacyPolicyPage.ParagraphFour.ListItem.One")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphFour.ListItem.Two")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphFour.ListItem.Three")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphFour.ListItem.Four")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphFour.ListItem.Five")}</li>
          </ul>
          <p>{t("PrivacyPolicyPage.ParagraphFour.AdditionalInformation")}</p>
        </div>
        <div className="paragraph-container">
          <h2>5. {t("PrivacyPolicyPage.ParagraphFive.Title")}</h2>
          <p>{t("PrivacyPolicyPage.ParagraphFive.List.Description")}</p>
          <ul>
            <li>{t("PrivacyPolicyPage.ParagraphFive.ListItem.One")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphFive.ListItem.Two")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphFive.ListItem.Three")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphFive.ListItem.Four")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphFive.ListItem.Five")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphFive.ListItem.Six")}</li>
          </ul>
          <p>{t("PrivacyPolicyPage.ParagraphFive.AdditionalInformation")}</p>
        </div>
        <div className="paragraph-container">
          <h2>6. {t("PrivacyPolicyPage.ParagraphSix.Title")}</h2>
          <p>{t("PrivacyPolicyPage.ParagraphSix.Description")}</p>
        </div>
        <div className="paragraph-container">
          <h2>7. {t("PrivacyPolicyPage.ParagraphSeven.Title")}</h2>
          <p>{t("PrivacyPolicyPage.ParagraphSeven.List.Description")}</p>
          <ul>
            <li>{t("PrivacyPolicyPage.ParagraphSeven.ListItem.One")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphSeven.ListItem.Two")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphSeven.ListItem.Three")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphSeven.ListItem.Four")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphSeven.ListItem.Five")}</li>
            <li>{t("PrivacyPolicyPage.ParagraphSeven.ListItem.Six")}</li>
          </ul>
          <p>{t("PrivacyPolicyPage.ParagraphSeven.AdditionalInformation")}</p>
        </div>
        <div className="paragraph-container">
          <h2>8. {t("PrivacyPolicyPage.ParagraphEight.Title")}</h2>
          <p>{t("PrivacyPolicyPage.ParagraphEight.Description")}</p>
          <p>Folkets Advokatbyrå</p>
          <p>Chapmansgatan 5, 112 36, Stockholm</p>
          <p>08 650 02 44</p>
          <p>info@folketsadvokatbyra.se</p>
        </div>
        <div className="paragraph-container">
          <h2>9. {t("PrivacyPolicyPage.ParagraphNine.Title")}</h2>
          <p>{t("PrivacyPolicyPage.ParagraphNine.Description")}</p>
        </div>
        <div className="paragraph-container">
          <h2>10. {t("PrivacyPolicyPage.ParagraphTen.Title")}</h2>
          <p>{t("PrivacyPolicyPage.ParagraphTen.Description")}</p>
        </div>
      </div>
    </div>
  );
}
